import { call } from '../../../../stent/call';
import { Cart } from '../../../schema';
export const makeRefresh = function(ctx) {
    const { fetchCartContents  } = ctx;
    return function* refresh(machine) {
        try {
            if (machine.state.contents == null) {
                throw new Error('Cart contents missing');
            }
            yield {
                name: 'Refreshing',
                error: null,
                contents: machine.state.contents
            };
            const firstPass = yield call(fetchCartContents, undefined);
            const contents = Cart.create(firstPass);
            yield {
                contents,
                name: 'Ready',
                error: null
            };
        } catch (err) {
            yield {
                error: err instanceof Error ? err : new Error('Unknown error [e9022a2fa11a4051b7b1b4141132a0d8]'),
                name: 'Failure',
                contents: machine.state.contents
            };
        }
    };
};
